import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import Route from '@ember/routing/route';

export type CoachesIndexModel = CoachingCoacheeCohortModel;

export default class CoachingCoacheeCohortCoachesIndexRoute extends Route<CoachesIndexModel> {
  model(): CoachesIndexModel {
    return this.modelFor(
      'coaching.coachee.cohort.coaches'
    ) as CoachingCoacheeCohortModel;
  }

  queryParams = {
    searchQuery: { as: 'q', replace: true, scope: 'controller' },
    sort: { replace: true, scope: 'controller' },
    specialty: { replace: true, scope: 'controller' },
    language: { replace: true, scope: 'controller' },
    industry: { replace: true, scope: 'controller' },
    country: { replace: true, scope: 'controller' },
  };
}
